<template>
	<div class="alert" @click="$emit('click')">
		<slot name="title"></slot>
		<div v-if="title">{{ title }}</div>
		<i v-if="close" class="el-icon-close" @click.stop="$emit('close')"></i>
	</div>
</template>
<script>
export default {
	name: 'alert',
	props: {
		title: {
			type: String,
			default: '',
		},
		close: {
			type: Boolean,
			default: true,
		},
	},
};
</script>
<style lang="scss">
.alert {
	border-radius: 4px;
	font-size: 12px;
	line-height: 1;
	color: #333333;
	background-color: #F8F8F8;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 14px;
	cursor: pointer;

	&:hover {
		color: #3DA1FF;
	}
}
</style>
